import {
  SEND_TO_BERGEN_REQUEST,
  SEND_TO_BERGEN_SUCCESS,
  SEND_TO_BERGEN_ERROR
  } from "../actions/types";
  
  export const sendToBergen = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case   SEND_TO_BERGEN_REQUEST:
        return {
          loading: true,
        };
      case   SEND_TO_BERGEN_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case   SEND_TO_BERGEN_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  